import keys from "./keys";

const translate: { [k: string]: string } = {
  [keys.CompanyCountry]: "País da empresa",
  [keys.ChannelsSubmit]: "Enviar",
  [keys.Step]: "Passo",
};

export default translate;
